import React, { useEffect, useState,useContext } from 'react';
import { IconButton,Tooltip } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { ModeContext } from './ModeContext';
import { useNavigate ,useLocation } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';

const ButtonSetting = ({ onClick }) => {
  const { isComponentAVisible, setIsComponentAVisible, loginInfo, setActiveAdminComponent, setDisplayMode, setIsUploadMode, setActiveButton} = useContext(ModeContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSwitchComponent = () => {
    setIsComponentAVisible((prev) => !prev);
  };

  // ボタンクリック時の動作
  const handleButtonClick = () => {
    if (location.pathname === '/settings') {
        navigate('/'); // ホームへ移動
      } else {
        navigate('/settings'); // 設定へ移動
      }
  };

  const handleClick = () => {
    if (location.pathname === '/settings') {
      // チャット画面に戻る際の状態設定
      setDisplayMode('chat');
      setIsUploadMode(false);
      setActiveButton('chat');
      navigate('/'); // ホームへ移動
    } else {
      // 権限に応じてデフォルト表示を設定
      if (loginInfo.authorityId === 'HQ') {
        setActiveAdminComponent('AdminUserSetting');
      } else if (loginInfo.authorityId === 'admin') {
        setActiveAdminComponent('AdminUserSetting');
      } else {
        setActiveAdminComponent('AdminPromptSetting');
      }
      navigate('/settings'); // 設定へ移動
    }
  };

  return (
    <Tooltip title={location.pathname === '/settings' ? "ホームに戻る" : "設定"}>
    <IconButton onClick={handleClick} color="inherit"
      sx={{
        bgcolor: "#777777",
        color: "white",
        borderRadius: "50%",
        width: "32px",
        height: "32px",
      }}>
      {location.pathname === '/settings' ? <HomeIcon /> : <SettingsIcon />}
    </IconButton>
  </Tooltip>


  );
};

export default ButtonSetting;
